import {Component, Inject, Input, Output, Pipe, PipeTransform, ViewChild, HostListener, EventEmitter, OnDestroy, ViewChildren, QueryList} from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {ApiService} from '../shared/api.service';
import {Site} from '../shared/site.model';
import { finalize } from 'rxjs/operators';
import {ImagesService} from '../shared/images.service';
import {Utils} from '../utils';
import { PermissionsService } from '../shared/permissions.service';
import { Permissions } from '../shared/permissions.enum';

@Pipe({name: 'siteSearch'})
export class SiteSearchPipe implements PipeTransform {
    transform(list, text): string {
        if( !list || !text ) {
            return list;
        }
        return list.filter(item => {
            const blog_id = item.blog_id + '';
            return item.name.indexOf(text) !== -1 || 
                item.domain.indexOf(text) !== -1 || 
                blog_id.indexOf(text) !== -1 || 
                item.abbreviation.indexOf(text) !== -1 ? true : false;
        });
    }
}
@Pipe({
    name: 'hasSite',
    pure: false
})
export class HasSitePipe implements PipeTransform {
    transform(list, sites): string {
        if( !list || !sites ) {
            return list;
        }
        const blog_ids = sites.map(site => site.blog_id);
        return list.filter(item => {
            return blog_ids.indexOf(item.blog_id) === -1;
        });
    }
}

@Pipe({name: 'termSearch'})
export class TermSearchPipe implements PipeTransform {
    transform(list, text): string {
        if( !list || !text ) {
            return list;
        }
        text = text.toLowerCase();
        return list.filter(item => {
            return item.name.toLowerCase().indexOf(text) !== -1;
        });
    }
}

@Component({
    selector: 'properties-component',
    templateUrl: 'properties.component.html'
})
export class PropertiesComponent implements OnDestroy {
    limited = false;
    options = [];
    panelOpen = false;
    siteSearchText = '';
    hideKeys = [
        'hideOnFront', 
        'hideOnCategory',
        'hideOnTag',
        'hideOnDate',
        'hideOnAuthor',
        'hideOnSearch',
        'hideOnFeed',
        'hideOnGoogle'
    ];
    primaryCategories = [];
    inputRand = this.utils.rand();

    private _canEdit = false;
    private _slideshowLocked? = false;
    private _editMeta = true;
    private _editSlug = true;
    private _properties = [];
    private _label = 'Property';
    private _showMeta = true;
    private _showFacebook = false;
    private _showCategory = true;
    private _showPermalink = true;
    private _assignment;
    private _taxOptions;

    @Input('assignment')
    set assignment(assignment) {
        this._assignment = assignment;
    }
    get assignment() {
        return this._assignment;
    }
    @Input('canEdit')
    set canEdit(canEdit) {
        this._canEdit = canEdit;
    }
    get canEdit() {
        return this._canEdit;
    }

    @Input('slideshowLocked')
    set slideshowLocked(slideshowLocked) {
        this._slideshowLocked = slideshowLocked;
    }
    get slideshowLocked() {
        return this._slideshowLocked;
    }

    @Input('label') 
    set label(label) {
        this._label = label;
    }
    get label() {
        return this._label;
    }
    @Input('editMeta') 
    set editMeta(editMeta) {
        this._editMeta = editMeta;
    }
    get editMeta() {
        return this._editMeta;
    }
    @Input('editSlug') 
    set editSlug(editSlug) {
        this._editSlug = editSlug;
    }
    get editSlug() {
        return this._editSlug;
    }
    @Input('properties') 
    set properties(properties) {
        this._properties = properties;
    }
    get properties() {
        return this._properties;
    }
    @Input('showMeta') 
    set showMeta(showMeta) {
        this._showMeta = showMeta;
    }
    get showMeta() {
        return this._showMeta;
    }
    @Input('showFacebook') 
    set showFacebook(showFacebook) {
        this._showFacebook = showFacebook;
    }
    get showFacebook() {
        return this._showFacebook;
    }
    @Input('showCategory') 
    set showCategory(showCategory) {
        this._showCategory = showCategory;
    }
    get showCategory() {
        return this._showCategory;
    }
    @Input('showPermalink') 
    set showPermalink(showPermalink) {
        this._showPermalink = showPermalink;
    }
    get showPermalink() {
        return this._showPermalink;
    }
    @Input('taxOptions') 
    set taxOptions(taxOptions) {
        this._taxOptions = taxOptions;
    }
    get taxOptions() {
        return this._taxOptions;
    }

    @Output() propertiesChange = new EventEmitter();
    @Output() propertyChanged = new EventEmitter(); // when a Site is added through the ui
    @Output() propertiesLoaded = new EventEmitter(); // when the list of Sites is loaded

    @ViewChildren('siteCategory') siteCategoryEls;

    @ViewChild('dropdown') dropdown;
    @HostListener('document:click', ['$event'])
    clickout(event) {
        if( this.dropdown && !this.dropdown.nativeElement.contains(event.target)) {
            this.panelOpen = false;
        }
    }

    constructor(private api: ApiService, private dialog: MatDialog, public utils: Utils, public permissionsService: PermissionsService) {
        const siteOptions = this.api.getProp('sites');
        this.options = siteOptions.map(item => new Site(item));
    }
    ngAfterViewInit() {
        const user = this.api.getProp('user');
        if( user.limited.length > 0 ) {
            this.limited = true;
            this.options = this.options.filter(item => user.limited.indexOf(item.blog_id) !== -1);
            if( this.options.length == 1 ) {
                const option = this.options.shift();
                const properties = this.properties;
                for(var i = 0; i < properties.length; i++) {
                    if( properties[i].blog_id == option.blog_id ) {
                        return;
                    }
                }
                this.addSite(option);
            }
        }
        this.propertiesLoaded.emit(this.options)
    }
    /**
     * override current this.properties array
     * @param ids (int[]) A list of blog_id to use for repopulating the properties
     */
    setSitesFromBlogId(receivedIds) {
        const sitesFound = []
        receivedIds.forEach(i => {
            const found = this.options.find(anOption => anOption.blog_id == i)
            if (found) sitesFound.push(found)
        })
        this.properties = []
        sitesFound.forEach(i => {
            this.addSite(i)
        })
    }
    addSite(option) {
        const site = JSON.parse(JSON.stringify(option));
        if( this.properties.length == 0 ) {
            site.primary = true;
        }
        if( !site.primary ) {
            this.addPrimaryCats(site);
            this.hidePost(site, true);
        }
        this.siteSearchText = '';
        this.properties.push(site);
        this.propertiesChange.emit(this.properties);
        this.propertyChanged.emit({ action: 'add', property: option })
    }
    addPrimaryCats(site) {
        const primary = this.properties.filter(item => item.primary).shift();
        if( primary ) {
            site.primaryCats = JSON.parse(JSON.stringify(primary.categories));
        }
    }
    updateSiteCategories(e) {
        if( e.site.primary && e.added && this.siteCategoryEls ) {
            const slugs = e.site.categories.map(item => item.slug);
            this.siteCategoryEls.toArray().forEach(el => {
                if( !el.site.primary ) {
                    const options = el.options;
                    for(var i = 0; i < options.length; i++) {
                        const option = options[i];
                        if( slugs.indexOf(option.slug) !== -1 ) {
                            option.checked = true;
                            el.changeOption(option);
                        }
                    }
                }
            });
        }
        if( e.site.primary ) {
            this.primaryCategories = e.site.categories;
        }
    }
    hidePost(site, hide) {
        const hideKeys = this.hideKeys;
        for(var i = 0; i < hideKeys.length; i++) {
            const key = hideKeys[i];
            site.meta[key] = hide;
        }
    }
    isChecked(site) {
        const hideKeys = this.hideKeys;
        for(var i = 0; i < hideKeys.length; i++) {
            const hide = site.meta[hideKeys[i]];
            if( hide == false ) {
                return false;
            }
        }
        return true;
    }
    isIndeterminate(site) {
        const hideKeys = this.hideKeys;
        let hasTrueValue = false;
        let hasFalseValue = false;
        for(var i = 0; i < hideKeys.length; i++) {
            const hide = site.meta[hideKeys[i]];
            if( hide == true ) {
                hasTrueValue = true;
            } else {
                hasFalseValue = true;
            }
        }
        return hasTrueValue && hasFalseValue;
    }
    openEditMeta(site) {
        if( !this.showMeta ) {
            return;
        }
        const dialog = this.dialog.open(SiteSettingsDialog, {
            data: {
                site: site,
                isChecked: this.isChecked(site),
                canEdit: this.canEdit && this.editMeta,
                slideshowLocked: this.slideshowLocked,
                hideKeys: this.hideKeys,
                showFacebookSettings: this.showFacebook,
                assignment: this.assignment
            }
        });
    }
    openEditSlug(site) {
        const dialog = this.dialog.open(SlugDialog, {
            data: {
                site: site,
                published: this.assignment.published
            }
        });
    }
    openSiteSelect(search) {
        search.focus();
        this.togglePanel(true);
    }
    removeSite(index) {
        const deletedProperties = this.properties.splice(index, 1);
        this.updatePrimary();
        this.propertiesChange.emit(this.properties);
        if (deletedProperties.length > 0) this.propertyChanged.emit({ action: 'remove', property: deletedProperties[0] })
    }
    togglePanel(open) {
        if( open ) {
            this.panelOpen = true;
            return;
        }
        this.panelOpen = !this.panelOpen;
    }
    updatePrimary() {
        const sites = this.properties;
        if( sites.length == 0 ) {
            return;
        }
        for(var i = 0; i < sites.length; i++) {
            if( sites[i].primary ) {
                return;
            }
        }
        sites[0].primary = true;
        this.hidePost(sites[0], false);
    }
    updateTerms(site, data) {
        site.taxonomies.category = data;
        if( site.primary ) {
            return;
        }
        const primary = this.properties.filter(item => item.primary).shift();
        if( !primary ) {
            return;
        }
        for(var tax in primary.taxonomies) {
            if( tax != 'category' && !site.taxonomies.hasOwnProperty(tax) ) {
                site.taxonomies[tax] = {
                    options: JSON.parse(JSON.stringify(primary.taxonomies[tax].options)),
                    terms: []
                };
            }
            const terms = primary.taxonomies[tax].terms.map(item => item.slug);
            let options = site.taxonomies[tax].options;
            for(var i = 0; i < options.length; i++) {
                let option = options[i];
                if( terms.indexOf(option.slug) !== -1 ) {
                    option.checked = true;
                    site.taxonomies[tax].terms.push(option);
                }
            }
        }
    }
    allSitesHaveCategory() {
        const sites = this.properties;
        for(var i = 0; i < sites.length; i++) {
            if( sites[i].categories.length === 0 ) {
                return false;
            }
        }
        return true;
    }
    openTaxOptions() {
        const dialog = this.dialog.open(TaxOptionsDialog, {
            data: {
                canEdit: this.canEdit,
                assignment: this.assignment,
                taxOptions: this.taxOptions
            }
        });
    }
    hasPATaxonomies() {
        const sites = this.assignment.sites;
        const taxes = this.assignment.taxonomies;
        const keys = Object.keys(taxes);
        for(var i = 0; i < sites.length; i++) {
            if( sites[i].blog_id == 14 ) {
                for(var i = 0; i < keys.length; i++) {
                    const key = keys[i];
                    if( 
                        (key == 'decade' && taxes[key].length > 0) || 
                        (key == 'genre' && taxes[key].length > 0) || 
                        (key == 'tv-show' && taxes[key].length > 0) || 
                        (key == 'actor' && taxes[key].length > 0)
                    ) {
                        return true;
                    }
                }
                return false;
            }
        }
        return true;
    }
    ngOnDestroy() {
        this.panelOpen = false;
        this.siteSearchText = '';
    }
}
@Component({
    selector: 'site-settings-dialog',
    template: `
        <button [mat-dialog-close]="false" class="close faded"><mat-icon>close</mat-icon></button>
        <div mat-dialog-title>
            Settings 
            <a 
                id="title-icon"
                href="{{data.site?.permalink}}" 
                target="_blank" 
                class="site-{{data.site.abbreviation}}"
                [ngClass]="{primary: data.site.primary}">
                    {{data.site.abbreviation}}
            </a>
        </div>
        
        <mat-dialog-content class="groups">
            <div class="group">
                <mat-slide-toggle 
                    id="publish-toggle" 
                    [disabled]="!canEdit" 
                    [(ngModel)]="publish" 
                    (change)="setStatus($event)" 
                    [ngClass]="{warn: !publish}">
                    Publish
                </mat-slide-toggle>
            </div>
            <div class="group">
            <label>Published Date</label>
                <mat-form-field>
                    <input matInput 
                        id="publish-date"
                        type="datetime-local"
                        [(value)]="publishDate"
                        (change)="updatePublishDate($event)"
                        [readonly]="!canEdit">
                </mat-form-field>
            </div>
            <div class="group">
                <label>Next Post Link</label>
                <div class="input-wrap">
                    <textarea 
                        id="next-post-link" 
                        placeholder="URL"
                        [readonly]="!canEdit" 
                        [(ngModel)]="data.site.nextPostLink" 
                        (input)="updateNextPostLink()" 
                        (keydown.enter)="$event.preventDefault()">
                    </textarea>
                </div>
            </div>
            <div class="group">
                <mat-slide-toggle 
                    *ngIf="data.showFacebookSettings"
                    id="fb-toggle" 
                    [disabled]="!canEdit"
                    (change)="toggleFb($event)"
                    [(ngModel)]="showFb"
                    [ngClass]="{active: showFb}">
                    Custom Facebook Meta
                </mat-slide-toggle>
            </div>
            <div *ngIf="showFb && data.showFacebookSettings" id="fb-settings" class="group">
                <div class="image">
                    <ng-container *ngIf="data.site.meta.facebookImage; else placeholder">
                        <img [src]="getSrc()" (click)="openImages()">
                    </ng-container>
                    <ng-template #placeholder>
                        <div class="placeholder" (click)="openImages()"><div><mat-icon>insert_photo</mat-icon></div></div>
                    </ng-template>
                </div>
                <div class="wysiwyg">
                    <label>Facebook Meta Title</label>
                    <richtext
                        [(value)]="data.site.meta.facebookTitle"
                        placeholder="Facebook Meta Title"
                        *ngIf="canEdit; else metaTitleEl"
                        [removeButtons]="true">
                    </richtext>
                    <ng-template #metaTitleEl>
                        <div [ngClass]="{faded: !data.site.meta.facebookTitle}">{{data.site.meta.facebookTitle ? data.site.meta.facebookTitle : 'Facebook Meta Title'}}</div>
                    </ng-template>
                    <div class="word-count">{{data.site.meta.facebookTitle ? data.site.meta.facebookTitle.length : 0}}/60</div>
                </div>
                <div class="wysiwyg">
                    <label>Facebook Meta Description</label>
                    <richtext
                        [(value)]="data.site.meta.facebookDescription"
                        placeholder="Facebook Meta Description"
                        *ngIf="canEdit; else metaDescEl"
                        [removeButtons]="true">
                    </richtext>
                    <ng-template #metaDescEl>
                        <div [ngClass]="{faded: !data.site.meta.facebookDescription}">{{data.site.meta.facebookDescription ? data.site.meta.facebookDescription : 'Facebook Meta Description'}}</div>
                    </ng-template>
                    <div class="word-count">{{data.site.meta.facebookDescription ? data.site.meta.facebookDescription.length : 0}}/160</div>
                </div>
            </div>
            <div class="group">
                <mat-checkbox [disabled]="!canEditHideOnPage" (change)="update($event)" [(ngModel)]="data.site.meta.hideOnFront"> Hide on front page </mat-checkbox><br/>
                <mat-checkbox [disabled]="!canEditHideOnPage" (change)="update($event)" [(ngModel)]="data.site.meta.hideOnCategory"> Hide on category pages </mat-checkbox><br/>
                <mat-checkbox [disabled]="!canEditHideOnPage" (change)="update($event)" [(ngModel)]="data.site.meta.hideOnTag"> Hide on tag pages </mat-checkbox><br/>
                <mat-checkbox [disabled]="!canEditHideOnPage" (change)="update($event)" [(ngModel)]="data.site.meta.hideOnDate"> Hide on date archives </mat-checkbox><br/>
                <mat-checkbox [disabled]="!canEditHideOnPage" (change)="update($event)" [(ngModel)]="data.site.meta.hideOnAuthor"> Hide on author pages </mat-checkbox><br/>
                <mat-checkbox [disabled]="!canEditHideOnPage" (change)="update($event)" [(ngModel)]="data.site.meta.hideOnSearch"> Hide in search results </mat-checkbox><br/>
                <mat-checkbox [disabled]="!canEditHideOnPage" (change)="update($event)" [(ngModel)]="data.site.meta.hideOnFeed"> Hide in feeds </mat-checkbox><br/>
                <mat-checkbox [disabled]="!canEditHideOnPage" (change)="update($event)" [(ngModel)]="data.site.meta.hideOnGoogle"> Hide from Google </mat-checkbox><br/>
                <mat-checkbox [disabled]="!canEditHideOnPage" (change)="selectAll($event)" [(ngModel)]="hideOnAll"> Hide on all </mat-checkbox><br/>   
            </div>         
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="true">Done</button>
        </mat-dialog-actions>`,
})
export class SiteSettingsDialog {
    hideOnAll;
    checking = false;
    saving = false;
    canEdit = false;
    canEditHideOnPage = false;
    publish = true;
    publishDate = '';
    formerDate = '';
    showFb = false;
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog, public permissionsService: PermissionsService) {
        this.hideOnAll = data.isChecked;
        this.canEdit = data.canEdit;
        this.canEditHideOnPage = permissionsService.userHasPermission(Permissions.HideOnPage) && !this.data.slideshowLocked;
        if( data.site.newStatus == 'draft' || !data.site.newStatus && data.site.status == 'draft' ) {
            this.publish = false;
        }
        if( data.site.meta.facebookImage || data.site.meta.facebookTitle || data.site.meta.facebookDescription ) {
            this.showFb = true;
        }
        if ( data.site.date && data.site.date != '' ) {
            this.formerDate = this.publishDate = data.site.date.replace(' ','T');
        }
    }
    get Permissions() {
        return Permissions;
    }

    getSrc() {
        return this.data.site.meta.facebookImage + '&v=' + Date.now();
    }
    selectAll(e) {
        const hide = e.checked;
        const site = this.data.site;
        const hideKeys = this.data.hideKeys;
        for(var i = 0; i < hideKeys.length; i++) {
            site.meta[hideKeys[i]] = hide;
        }
    }
    update(event) {
        if( !event.checked ) {
            this.hideOnAll = false;
        }
    }
    setStatus(e) {
        this.data.site.newStatus = e.checked ? 'publish' : 'draft';
        if (this.data.site.newStatus == 'publish' && this.publishDate == '') {
            this.publishDate = this.formerDate;
            this.data.site.date = this.publishDate.replace('T',' ');
        }
    }
    cleanLink() {
        return this.data.site.nextPostLink.trim().replace(/[^a-zA-Z0-9-\/:\.\?=&]/gi, '');
    }
    updateNextPostLink() {
        this.data.site.nextPostLink = this.cleanLink();
    }
    updatePublishDate(e) {
        if (e.target.value == '') {
            this.data.site.newStatus = 'draft';
            this.publish = false;
            this.publishDate = this.data.site.date = '';
        }
        else {
        this.publishDate = e.target.value;
        this.data.site.date = this.publishDate.replace('T',' ');
    }
    }
    removeFbImage() {
        this.data.site.meta.facebookImage = '';
        this.data.site.meta.facebookTitle = '';
        this.data.site.meta.facebookDescription = '';
        this.data.site.meta.socialImage = {};
    }
    toggleFb(e) {
        if( e.checked ) {
            this.showFb = true;
        } else {
            this.showFb = false;
            this.removeFbImage();
        }
    }
    openImages() {
        if( !this.data.canEdit ) {
            return;
        }
        const dialog = this.dialog.open(ImagesDialog, {
            data: {
                assignment: this.data.assignment
            }
        });
        dialog.afterClosed().subscribe(details => {
            if( details ) {
               this.data.site.meta.facebookImage = details.url;
               this.data.site.meta.socialImage = details;
            }
        });
    }
}
@Component({
    selector: 'slug-dialog',
    template: `
        <button [mat-dialog-close]="false" class="close faded"><mat-icon>close</mat-icon></button>
        <div mat-dialog-title>
            Edit Slug <a id="title-icon"
                        href="{{data?.site.permalink}}" 
                        target="_blank" 
                        class="site-{{data.site.abbreviation}}"
                        [ngClass]="{primary: data.site.primary}">
                            {{data.site.abbreviation}}
                    </a>
        </div>
        
        <mat-dialog-content id="slug">
            <slug-component 
                [(slug)]="desiredSlug"
                [blog_id]="data.site.blog_id"
                [post_id]="data.site.post_id"
                (propChange)="updateProp($event)">
            </slug-component>
        </mat-dialog-content>
        <mat-dialog-actions>
            <img class="loader" *ngIf="loading" src="/wp-content/themes/swarm/app/assets/images/loading.gif">
            <button class="button" [mat-dialog-close]="false">Cancel</button>
            <button class="button" [disabled]="checked && !available" (click)="updateSlug()">Update</button>
        </mat-dialog-actions>`,
})
export class SlugDialog {
    available = false;
    checked = false;
    loading = false;
    published = false;
    desiredSlug = '';
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private api: ApiService, private dialogRef: MatDialogRef<SlugDialog>) {
        this.desiredSlug = data.site.slug;
        if(data.published === undefined) {
            this.published = true;
        } else {
            this.published = data.published;
        }
    }
    updateProp(event) {
        this.loading = event.loading;
        this.checked = event.checked;
        this.available = event.available;
    }
    updateSlug() {
        this.api.doAction('post', 'sites', {
            action: 'update_slug',
            blog_id: this.data.site.blog_id,
            slug: this.desiredSlug,
            post_id: this.data.site.post_id
        }).pipe(
            finalize(() => {
                this.loading = false;
            })
        ).subscribe(
            data => {
                this.data.site.permalink = data.permalink;
                this.data.site.slug = data.slug;
                this.data.site.oldSlug = data.oldSlug;
                this.data.site.desiredSlug = data.slug;

                this.dialogRef.close(data);
            }
        );
    }
}
@Component({
    selector: 'images-dialog',
    template: `
        <button [mat-dialog-close]="false" class="close faded"><mat-icon>close</mat-icon></button>
        <div mat-dialog-title>
            Select Image
        </div>
        
        <mat-dialog-content 
            id="image-select" 
            dndDropzone 
            (dndDrop)="drop($event)"
            [dndAllowExternal]="true">
            <div class="placeholder">
                <mat-icon>insert_photo</mat-icon>
            </div>
            <div class="images">
                <div class="image"
                    *ngFor="let image of imagesService.images" 
                    (click)="selectImage(image)"
                    [ngStyle]="{
                        'background-image' : 'url(' + image.url + '?width=1200&height=630)'
                    }">
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <img *ngIf="imagesService.uploadInProgress" src="/wp-content/themes/swarm/app/assets/images/loading.gif" class="loader"/>
            <button class="button" [mat-dialog-close]="false">Close</button>
        </mat-dialog-actions>`,
})
export class ImagesDialog {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<ImagesDialog>, public imagesService: ImagesService) {}
    selectImage(image) {
        const url = image.url + '?width=1200&height=630';
        this.dialogRef.close({
            url: url,
            width: 1200,
            height: 630,
            alt: image.alt
        });
    }
    drop(e) {
        const files = e.event.dataTransfer.files;
        let count = files.length;
        const imageUploadSubscription = this.imagesService.imageUploaded.subscribe(img => {
            count -= 1;
            if( !img.error ) {
                this.selectImage(img);
            }
            if( count == 0 ) {
                imageUploadSubscription.unsubscribe();
            }
        });
        this.imagesService.handleDropFiles(files, this.data.assignment, true);
    }
}
@Component({
    selector: 'tax-options-dialog',
    template: `
        <div mat-dialog-title>
            Taxonomy Options
        </div>
        <mat-dialog-content id="site-taxonomy">
            <mat-accordion>

                <mat-expansion-panel [expanded]="(i == 0)" *ngFor="let tax of taxOptions; trackBy: utils.trackByIndex; let i = index;">
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{tax.name}}</mat-panel-title>
                        <mat-panel-description>{{getSelectedText(tax)}}</mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="inner">
                        <span class="input-wrap">
                            <input type="text" placeholder="Search{{data.canEdit ? '/Add' : ''}}" [(ngModel)]="tax.newTerm" (keydown.enter)="addTerm(tax)">
                        </span>

                        <div class="taxonomy" *ngIf="tax.hierarchical; else letterKeysTemplate">
                            <span class="term" [ngClass]="{active: option.checked}" *ngFor="let option of (tax.options | termSearch: tax.newTerm)" (click)="selectOption(tax, option)">{{option.name}}</span>
                        </div>

                        <ng-template #letterKeysTemplate>
                            <ul class="letters" *ngIf="!tax.newTerm">
                                <li class="letter" [ngClass]="{active: tax.selectedLetter == letter}"  (click)="selectLetter(tax, letter)" *ngFor="let letter of tax.keys; trackBy: utils.trackByIndex">{{letter}}</li>
                            </ul>
                            <ul class="selected-options">
                                <li *ngFor="let option of ( getSelectedOptions(tax) ); trackBy: utils.trackByIndex">
                                    <mat-checkbox [disabled]="!data.canEdit" [checked]="option.checked" (change)="selectOption(tax, option)"> {{option.name}} </mat-checkbox>
                                </li>
                            </ul>
                            <ul class="taxonomy-list" *ngIf="!tax.newTerm; else showSearch">
                                <li *ngFor="let option of tax.letters[tax.selectedLetter]">
                                    <mat-checkbox [disabled]="!data.canEdit" [checked]="option.checked" (change)="selectOption(tax, option)"> {{option.name}} </mat-checkbox>
                                </li>
                            </ul>
                            <ng-template #showSearch>
                                <ul class="taxonomy-list">
                                    <ng-container *ngFor="let option of (tax.options | termSearch: tax.newTerm); let i = index; trackBy: utils.trackByIndex">
                                        <li *ngIf="i < 20">
                                            <mat-checkbox [disabled]="!data.canEdit" [checked]="option.checked" (change)="selectOption(tax, option)"> {{option.name}} </mat-checkbox>
                                        </li>
                                    </ng-container>
                                </ul>
                            </ng-template>
                        </ng-template>

                    </div>
                </mat-expansion-panel>
                
            </mat-accordion>
        </mat-dialog-content>
        <mat-dialog-actions>
            <img *ngIf="loading" src="/wp-content/themes/swarm/app/assets/images/loading.gif" class="loader"/>
            <button class="button" [mat-dialog-close]="false">Done</button>
        </mat-dialog-actions>`,
})
export class TaxOptionsDialog {
    taxOptions = [];
    loading = false;
    error = '';
    newDecade = '';
    newGenre = '';
    newShow = '';
    newActor = '';
    selectedShow;
    selectedActor;
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private api: ApiService, public utils: Utils) {
        this.setTaxOptions();
    }
    getSelectedOptions(tax) {
        const options = tax.options.filter(item => item.checked);
        options.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
        });
        return  options;
    }
    getTaxonomies() {
        const taxonomies = this.api.getProp('taxonomies');
        const paTaxonomies = JSON.parse(JSON.stringify( this.api.getProp('paTaxonomies') ));
        paTaxonomies.decade = JSON.parse(JSON.stringify(taxonomies.decade));
        return paTaxonomies;
    }
    setTaxOptions() {
        let taxonomies = this.data.taxOptions;
        if( !taxonomies ) {
            taxonomies = this.getTaxonomies();
        }
        const keys = Object.keys(taxonomies);
        const assignmentTaxes = this.data.assignment.taxonomies;
        const taxOptions = [];
        for(var i = 0; i < keys.length; i++) {
            const key = keys[i];
            const tax = taxonomies[key];
            tax.newTerm = '';
            if( assignmentTaxes[key] ) {
                const options = tax.options;
                const names = assignmentTaxes[key].map(item => item.name.toLowerCase());
                for(var j = 0; j < options.length; j++) {
                    const option = options[j];
                    const name = option.name.toLowerCase();
                    if( names.indexOf(name) !== -1 ) {
                        option.checked = true;
                    }
                }
            }
            if( tax.hierarchical === false ) {
                this.setLetterKeys(tax);
            }
            taxOptions.push(tax);
        }
        this.taxOptions = taxOptions;
    }
    setLetterKeys(tax) {
        tax.letters = {};
        tax.keys = [];
        const options = tax.options;
        let current;
        let letterFound = false;
        for(var i = 0; i < options.length; i++) {
            const option = options[i];
            const name = option.name.toLowerCase();
            const letter = name.charAt(0);
            if( option.checked && !letterFound ) {
                tax.selectedLetter = letter;
                letterFound = true;
            }
            if( current !== letter ) {
                current = letter;
                tax.letters[current] = [];
                tax.keys.push(current);
            }
            tax.letters[current].push(option);
        }
        tax.keys.sort();
        if( !letterFound && tax.keys.length > 0 ) {
            tax.selectedLetter = tax.keys[0];
        }
    }
    selectOption(tax, option) {
        if( !this.data.canEdit ) {
            return;
        }
        const slug = tax.slug;
        const assignment = this.data.assignment;
        if( option.checked ) {
            option.checked = false;
            const assignmentTax = assignment.taxonomies[slug];
            if( !assignmentTax ) {
                return;
            }
            let i = assignmentTax.length;
            while(i--) {
                if( assignmentTax[i].name.toLowerCase() == option.name.toLowerCase() ) {
                    assignmentTax.splice(i, 1);
                    if( assignmentTax.length == 0 ) {
                        delete this.data.assignment.taxonomies[slug];
                    }
                }
            }
        } else {
            if( !assignment.taxonomies[slug] ) {
                assignment.taxonomies[slug] = [];
            }
            option.checked = true;
            assignment.taxonomies[slug].push({
                slug: option.slug,
                name: option.name,
                term_id: option.term_id
            });
        }
    }
    selectLetter(tax, letter) {
        tax.selectedLetter = letter;
    }
    addTerm(tax) {
        if( !this.data.canEdit ) {
            return;
        }
        const text = tax.newTerm.trim();
        if( !text ) {
            return;
        }
        const assignmentTaxes = this.data.assignment.taxonomies;
        const slug = tax.slug;
        if( !assignmentTaxes[slug] ) {
            assignmentTaxes[slug] = [];
        }
        const newOption = {
            name: text,
            checked: true
        };
        assignmentTaxes[slug].push({
            name: newOption.name
        });
        tax.options.push(newOption);
        if( tax.hierarchical === false ) {
            const letter = newOption.name.toLowerCase().charAt(0);
            tax.selectedLetter = letter;
            const letterList = tax.letters[letter];
            if( !letterList ) {
                tax.letters[letter] = [];
                tax.keys.push(letter);
                tax.keys.sort();
            }
            tax.letters[letter].unshift(newOption);
        }
        tax.newTerm = '';
    }
    getSelectedText(tax) {
        const options = tax.options.filter(item => item.checked).map(item => item.name);
        options.sort();
        return options.join(', ');
    }
}